/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetBalanceRegisterInfo } from './assetBalanceRegisterInfo';

export interface RegisterBalanceInfo {
  ledgerId?: string;
  businessEntity?: RegisterBalanceInfo.BusinessEntityEnum;
  balances: Array<AssetBalanceRegisterInfo>;
}
export namespace RegisterBalanceInfo {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
